module.exports = __webpack_public_path__ + "static/media/ss.0678d330.svg";